const yearRange = (start, end) =>
  Array.from({ length: start - end + 1 }, (_, index) => String(start - index));

const makes = [
  "Acura", "Alfa Romeo", "Aston Martin", "Audi", "Bentley", "BMW", "Bugatti",
  "Buick", "Cadillac", "Chevrolet", "Chrysler", "Dodge", "Ferrari", "FIAT",
  "Fisker", "Ford", "Genesis", "GMC", "Honda", "Hummer", "Hyundai", "INFINITI",
  "Isuzu", "Jaguar", "Jeep", "Karma", "Kia", "Lamborghini", "Land Rover", "Lexus",
  "Lincoln", "Lotus", "Lucid", "Maserati", "Maybach", "Mazda", "McLaren",
  "Mercedes-Benz", "Mercury", "MINI", "Mitsubishi", "Nissan", "Oldsmobile",
  "Plymouth", "Polestar", "Pontiac", "Porsche", "Ram", "Rivian", "Rolls-Royce",
  "Saab", "Saturn", "Scion", "smart", "Subaru", "Suzuki", "Tesla", "Toyota",
  "VinFast", "Volkswagen", "Volvo",
];

const models = [
  "1500", "2500", "3500", "3 Series", "4 Series", "5 Series", "7 Series", "86",
  "A3", "A4", "A5", "A6", "A7", "A8", "Acadia", "Accent", "Accord", "Altima",
  "Armada", "Atlas", "Avalanche", "Avalon", "Aviator", "Beetle", "Blazer",
  "Bronco", "Bronco Sport", "C-Class", "C-HR", "Camaro", "Camry", "Canyon",
  "Carnival", "Cayenne", "Challenger", "Charger", "Cherokee", "Civic", "CLA",
  "Colorado", "Compass", "Continental", "Cooper", "Corolla", "Corvette", "CR-V",
  "Crosstrek", "Cruze", "CX-3", "CX-30", "CX-5", "CX-50", "CX-9", "Defender",
  "Durango", "E-Class", "Eclipse Cross", "EcoSport", "Edge", "Elantra", "Encore",
  "Enclave", "Envision", "Equinox", "ES", "Escalade", "Escape", "Expedition",
  "Explorer", "F-150", "F-250", "F-350", "Fiesta", "Fit", "Forester", "Forte",
  "Frontier", "Fusion", "G-Class", "GLA", "GLB", "GLC", "GLE", "GLS", "Golf",
  "Grand Caravan", "Grand Cherokee", "Grand Highlander", "GR Corolla", "GR Supra",
  "GTI", "GX", "Highlander", "HR-V", "I-PACE", "ID.4", "ILX", "Impala",
  "IONIQ 5", "IONIQ 6", "IS", "Jetta", "Journey", "K5", "Kicks", "Kona",
  "Legacy", "M3", "M4", "Macan", "Malibu", "Maverick", "Maxima", "Mazda3",
  "Mazda6", "MDX", "Mirage", "Model 3", "Model S", "Model X", "Model Y", "Murano",
  "Mustang", "Nautilus", "Navigator", "NX", "Odyssey", "Optima", "Outback",
  "Pacifica", "Palisade", "Panamera", "Passat", "Passport", "Pathfinder", "Pilot",
  "Prius", "Q3", "Q5", "Q7", "Q8", "Q50", "Q60", "QX50", "QX60", "QX80", "RAV4",
  "Ranger", "Renegade", "Ridgeline", "Rio", "Rogue", "Rogue Sport", "RX", "S-Class",
  "Santa Cruz", "Santa Fe", "Seltos", "Sentra", "Sequoia", "Sienna", "Sierra 1500",
  "Silverado 1500", "Sonata", "Sonic", "Sorento", "Soul", "Spark", "Sportage",
  "Suburban", "Tacoma", "Tahoe", "Taos", "Telluride", "Terrain", "Tiguan", "Titan",
  "TLX", "Trailblazer", "Traverse", "Trax", "Tucson", "Tundra", "Venza", "Venue",
  "Versa", "Wrangler", "WRX", "X1", "X3", "X5", "XC40", "XC60", "XC90", "XT4",
  "XT5", "XT6", "Yukon",
];

const trims = [
  "1794 Edition", "1LT", "2LT", "3LT", "Base", "Big Bend", "Black Label",
  "Calligraphy", "Carbon Edition", "Denali", "Denali Ultimate", "EcoBoost",
  "Elite", "Essential", "EX", "EX-L", "Grand Touring", "GT", "High Altitude",
  "High Country", "Hybrid", "King Ranch", "L", "Laramie", "Laredo", "Lariat",
  "Latitude", "LE", "Leather", "Limited", "Long Range", "LS", "LT", "LT Trail Boss",
  "LTZ", "Luxury", "LX", "M Sport", "N Line", "Overland", "Performance",
  "Platinum", "Premier", "Premium", "Premium Luxury", "Pro", "R/T", "Raptor",
  "Reserve", "RS", "Rubicon", "S", "Sahara", "SE", "SEL", "Select", "Signature",
  "SL", "SLE", "SLT", "Sport", "Sport S", "SR", "SR5", "ST", "Standard Range",
  "SV", "SX", "SXT", "Technology", "Titanium", "Touring", "Tradesman",
  "Trailhawk", "TRD Off-Road", "TRD Pro", "TRD Sport", "Unlimited", "Value",
  "Wilderness", "Work Truck", "X-Line", "X-Pro", "XL", "XLE", "XLT", "XSE",
  "Z71", "ZR2",
];

const bodyTypes = [
  "Cargo Van", "Chassis Cab", "Convertible", "Coupe", "Crew Cab", "Cutaway Van",
  "Extended Cab", "Full-Size SUV", "Hatchback", "Minivan", "Passenger Van",
  "Regular Cab", "Roadster", "Sedan", "SUV / Crossover", "Truck / Crew Cab",
  "Truck / Extended Cab", "Truck / Regular Cab", "Van", "Wagon",
];

const conditions = [
  "Used", "Certified", "New", "Wholesale", "Upcoming", "Demo", "Manager Special",
  "Fresh Trade", "As-Is", "Reconditioned", "Fleet", "Lease Return", "Salvage",
  "Classic", "Consignment",
];

const statuses = [
  "Ready", "Fresh arrival", "Certified", "Pending", "Sold", "Upcoming", "In inspection",
  "In reconditioning", "Awaiting photos", "Awaiting title", "Reserved", "On hold",
  "Coming soon", "Featured", "Manager special", "Wholesale", "Removed",
];

const exteriorColors = [
  "Antimatter Blue", "Beige", "Black", "Blue", "Bronze", "Brown", "Burgundy",
  "Champagne", "Charcoal", "Dark Blue", "Dark Gray", "Gold", "Graphite", "Gray",
  "Green", "Gun Metallic", "Ivory", "Lunar Rock", "Maroon", "Midnight Black",
  "Orange", "Pearl White", "Platinum White", "Purple", "Red", "Ruby Red", "Sand",
  "Silver", "Summit White", "Tan", "Teal", "White", "Yellow",
];

const interiorColors = [
  "Ash", "Beige", "Black", "Black (Charcoal)", "Brown", "Camel", "Charcoal",
  "Chestnut", "Cream", "Dark Gray", "Ebony", "Graphite", "Gray", "Ivory",
  "Jet Black", "Light Gray", "Mocha", "Red", "Saddle", "Sand", "Tan", "Taupe",
  "Two-Tone", "White",
];

const drivetrains = [
  "All-Wheel Drive", "AWD", "Four-Wheel Drive", "4WD", "4X2", "4X4",
  "Front-Wheel Drive", "FWD", "Rear-Wheel Drive", "RWD", "Dual Motor AWD",
  "Quad Motor AWD", "Part-Time 4WD", "Full-Time 4WD",
];

const transmissions = [
  "Automatic", "Manual", "Single-Speed Automatic", "Continuously Variable Transmission",
  "CVT", "Dual-Clutch Automatic", "6-Speed Automatic", "6-Speed Manual",
  "7-Speed Automatic", "7-Speed Dual-Clutch", "8-Speed Automatic",
  "9-Speed Automatic", "10-Speed Automatic", "5-Speed Manual", "4-Speed Automatic",
  "Electronic CVT", "Tiptronic Automatic",
];

const engines = [
  "Electric", "Dual Motor Electric", "Tri Motor Electric", "Range Extender",
  "H4", "H6", "I2", "I3", "I4", "I5", "I6", "R2", "V6", "V8", "V10", "V12",
  "W8", "W12", "1.5L I4", "2.0L I4", "2.4L I4", "2.5L I4", "3.0L I6",
  "3.5L V6", "3.6L V6", "4.0L V6", "5.0L V8", "5.3L V8", "5.7L V8",
  "6.2L V8", "6.4L V8", "Turbo I4", "Turbo V6", "Twin-Turbo V6",
  "Twin-Turbo V8", "Diesel I4", "Diesel I6", "Diesel V8", "Hybrid I4",
  "Hybrid V6", "Plug-in Hybrid",
];

const horsepower = [
  "Under 100 hp", "100 hp", "125 hp", "150 hp", "170 hp", "180 hp", "200 hp",
  "225 hp", "250 hp", "275 hp", "300 hp", "325 hp", "355 hp", "375 hp",
  "400 hp", "425 hp", "450 hp", "475 hp", "500+ hp", "600+ hp", "700+ hp",
  "800+ hp", "1000+ hp",
];

const fuelTypes = [
  "Gasoline", "Diesel", "Hybrid", "Plug-in Hybrid", "Electric", "Flex Fuel",
  "E85", "Compressed Natural Gas", "Hydrogen", "Biodiesel",
];

const doors = [
  "2 doors", "3 doors", "4 doors", "5 doors", "6 doors",
];

export const vehicleSelectOptions = {
  years: ["", ...yearRange(2027, 1990)],
  makes: ["", ...makes],
  models: ["", ...models],
  trims: ["", ...trims],
  bodyTypes: ["", ...bodyTypes],
  conditions,
  statuses,
  exteriorColors: ["", ...exteriorColors],
  interiorColors: ["", ...interiorColors],
  drivetrains: ["", ...drivetrains],
  transmissions: ["", ...transmissions],
  engines: ["", ...engines],
  horsepower: ["", ...horsepower],
  fuelTypes,
  doors: ["", ...doors],
};
